import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/components/Login.vue";
import Dashboard from "@/components/Dashboard.vue";

const Users = () => import("@/views/Users/User.vue");
const Roles = () => import("@/views/roles/roles.vue");
const Permisos = () => import("@/views/permisos/permisos.vue");
const Especialidades = () => import("@/views/especialidades/especialidades.vue");
const Juzgados = () => import("@/views/juzgados/juzgados.vue");
// const Peritos = () => import("@/views/peritos/perfil.vue");
const PeritoShow = () => import("@/views/peritos/show.vue");
const Solicitudes = () => import("@/views/peritos/solicitudes.vue");
const Solicitud = () => import("@/views/peritos/solicitud.vue");
const Cedula = () => import("@/views/peritos/cedulas.vue");
const Generales = () => import("@/views/peritos/generales.vue");
const Partido = () => import("@/views/peritos/partidos.vue");
const PeritoEspecialidad = () => import("@/views/peritos/especializacion.vue");
const Domicilios = () => import("@/views/peritos/domicilios.vue");
const Telefonos = () => import("@/views/peritos/telefonos.vue");
const Carreras = () => import("@/views/peritos/carreras.vue");

const Informes = () => import("@/views/Informes/list.vue");
// const Perfil = () => import("@/views/peritos/perfil.vue");
const Documento = () => import("@/views/peritos/documentos.vue");

const Centros = () => import("@/views/Centros/Centros.vue");
const Log = () => import("@/views/logs/log.vue");

const Initial = () => import("@/views/Initial.vue");
const UpdatePassword = () => import("@/components/UpdatePassword");
const Refrendo = () => import("@/views/peritos/Refrendo.vue");
const Extemporaneo = () => import("@/views/peritos/extemporaneo.vue");
const Reporte = () => import("@/views/peritos/reporte.vue");
const ReporteInformes = () => import("@/views/Informes/reporteInformes.vue");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
    alias: "/login"
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/initial",
    name: "Initial",
    component: Initial,
    meta: { authorize: ['superadmin', 'admin', 'perito'] }
  },
  {
    path: "/users",
    name: "Users",
    component: Users,
    meta: { authorize: ['superadmin', 'admin'] }
  },
  {
    path: "/roles",
    name: "Roles",
    component: Roles,
    meta: { authorize: ['superadmin'] }
  },
  {
    path: "/permisos",
    name: "Permisos",
    component: Permisos,
    meta: { authorize: ['superadmin'] }
  },
  {
    path: "/especialidades",
    name: "Especialidades",
    component: Especialidades,
    meta: { authorize: ['superadmin', 'admin'] }
  },
  {
    path: "/juzgados",
    name: "Juzgados",
    component: Juzgados,
    meta: { authorize: ['superadmin', 'admin'] }
  },
  {
    path: "/peritos",
    name: "Solicitudes",
    component: Solicitudes,
    meta: { authorize: ['superadmin', 'admin', 'visor'] }
  },
  {
    path: "/solicitud",
    name: "Solicitud",
    component: Solicitud,
    meta: { authorize: ['superadmin', 'admin', 'perito'] }
  },
  {
    path: "/cedulas",
    name: "Cedula",
    component: Cedula,
    meta: { authorize: ['superadmin', 'admin', 'perito'] }
  },
  {
    path: "/partidos",
    name: "Partido",
    component: Partido,
    meta: { authorize: ['superadmin', 'admin', 'perito','visor'] }
  },
  {
    path: "/especializacion",
    name: "PeritoEspecialidad",
    component: PeritoEspecialidad,
    meta: { authorize: ['superadmin', 'admin', 'perito','visor'] }
  },
  {
    path: "/domicilios",
    name: "Domicilios",
    component: Domicilios,
    meta: { authorize: ['superadmin', 'admin', 'perito'] }
  },
  {
    path: "/telefonos",
    name: "Telefonos",
    component: Telefonos,
    meta: { authorize: ['superadmin', 'admin', 'perito'] }
  },
  {
    path: "/carreras",
    name: "Carreras",
    component: Carreras,
    meta: { authorize: ['superadmin', 'admin', 'perito'] }
  },
  // {
  //   path: "/perfil",
  //   name: "Perfil",
  //   component: Perfil,
  //   meta: { authorize: ['superadmin', 'admin', 'perito'] }
  // },
  {
    path: "/documentos",
    name: "Documento",
    component: Documento,
    meta: { authorize: ['superadmin', 'admin', 'perito'] }
  },
  {
    path: "/perito/show",
    name: "PeritoShow",
    component: PeritoShow,
    props: true,
    meta: { authorize: ['superadmin', 'admin', 'perito', 'visor'] }
  },
  {
    path: "/generales",
    name: "Generales",
    component: Generales,
    props: true,
    meta: { authorize: ['superadmin', 'admin', 'perito', 'visor'] }
  },
  {
    path: "/informes",
    name: "Informes",
    component: Informes,
    meta: { authorize: ['superadmin', 'admin', 'perito', 'visor'] }
  },
  {
    path: "/updatepassword",
    name: "UpdatePassword",
    component: UpdatePassword,
    meta: { authorize: ['superadmin', 'admin', 'perito', 'visor'] }
  },
  {
    path: "/refrendo",
    name: "Refrendo",
    component: Refrendo,
    meta: { authorize: ['superadmin', 'admin', 'perito'] }
  },
  {
    path: "/extemporaneo",
    name: "Extemporaneo",
    component: Extemporaneo,
    meta: { authorize: ['superadmin'] }
  },
  {
    path: "/reporte/refrendos",
    name: "Reporte",
    component: Reporte,
    meta: { authorize: ['superadmin', 'admin', 'visor'] }
  },
  {
    path: "/reporte/informes",
    name: "ReporteInformes",
    component: ReporteInformes,
    meta: { authorize: ['superadmin', 'admin', 'visor'] }
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  const { authorize } = to.meta;
  const userLogged = JSON.parse(localStorage.getItem("user"));

  if (authorize) {
    //si si tiene restricciones la ruta
    if (!userLogged) {
      //y no esta logeado entonces a logear
      return next({
        path: "/"
      });
    }
    //checar si la routa esta restringida por algun role_id y  NO coincide el role_id del user logeado
    if (authorize.length && !authorize.includes(userLogged.roles[0].name)) {
      // console.log(userLogged.roles[0].name);
      return next({ path: "/initial" });
    }
  }
  if ((to.path === "/" || to.path === "/login") && userLogged) {
    return next({ path: "/initial" });
  }
  next();
});

export default router;
